(function($) {
    //$(document).ready(function(){
        if(window.innerWidth < 767){
            if ($('#mobileintro').length) {
                var visits = Cookies.get('visits') || 0;
                visits++;
                Cookies.set('visits', visits);
                if ( Cookies.get('visits') <= 1){
                    $('#mobileintro').animate({ opacity: 1 });
                    $('html').toggleClass('popup-showed');

                    var ii = 10;
                    var fade_out = function() {
                            $("#mobileintro").animate({opacity: 0.0}, 900, function(){
                            $("#mobileintro").css({'visibility':'hidden'});
                            $("#mobileintro").css({'display':'none'});
                        });
                        clearInterval(counter);
                        $('html').removeClass('popup-showed');
                        $('.site-container').css({visibility:"visible", opacity: 0.0}).animate({opacity: 1.0},900);
                        hideAddressBar();
                    };
                    const hide_intro = setTimeout(fade_out, 10000);
                    function count() {  
                        $("#introcountdown").html(ii--); 
                    }
                    var counter = setInterval(function(){ count(); },900);
                    $(document).on('click','#skipintrolink',function(e){
                        e.preventDefault();
                        clearTimeout(hide_intro);
                        clearInterval(counter);
                        $("#mobileintro").animate({opacity: 0.0}, 900, function(){
                            $("#mobileintro").css({'visibility':'hidden'});
                            $("#mobileintro").css({'display':'none'});
                        });
                        $('html').removeClass('popup-showed');
                        $('.site-container').css({visibility:"visible", opacity: 0.0}).animate({opacity: 1.0},900);
                        hideAddressBar();
                    });

                }else{
                    $('#mobileintro').hide();
                    $('.site-container').css({visibility:"visible", opacity: 0.0}).animate({opacity: 1.0},200);
                    hideAddressBar();
                }
            }
        }else{
            $('#mobileintro').hide();
            $('.site-container').css({visibility:"visible", opacity: 0.0}).animate({opacity: 1.0},900);
            hideAddressBar();
        }
        var scrollXYpopupmode;
        $( '.burger-wrapper .hamburger' ).click(function(){
            $(this).toggleClass('is-active');
            $('#navigationwrapper').css('top','0px');
            $('#navigationwrapper').css('maxHeight',($(window).height() - (3/100)*$(window).height())+'px');
            $('#navigationwrapper').css('--imaxHeight',($(window).height() - (3/100)*$(window).height())+'px');
            $('.back-drop').css('top','0px').fadeToggle();
            $('#navigationwrapper' ).animate({
                opacity: "toggle"
            });
            if($('#popupclosebtn').length==0){
                $('#navigationwrapper').prepend('<span id="popupclosebtn"></span>');
            }
            $('html').toggleClass('popup-showed');
        });
            $(document).on('click','#popupclosebtn', function(){
                console.log('clicked');
                console.log(scrollXYpopupmode);
                $( '.burger-wrapper .hamburger' ).click();
                $('html, body').animate({
                    scrollTop: scrollXYpopupmode
                }, 2000);
            });

        $('.back-drop').click(function(){
            $( '.burger-wrapper .hamburger' ).click();
        });
        $(document).on('click','.pbackdrop', function(){
            if($('.phone-details').hasClass('show')){
                $('.phone-details').removeClass('show');
            }
            $('.pbackdrop').hide();
        });
        $('.has-child-sign').click(function(e){
            e.preventDefault();
            $('#menu-header-menu > li').not($(this).parent()).each(function(){
                $(this).removeClass('expanded');
            });
            $(this).parent().toggleClass('expanded');
        })
        /*$('#menu-header-menu .menu-item-has-children:first').addClass('expanded');*/
        window.onkeyup = function (event) {
            if(event.keyCode == 27){
                var checkWidth = $(window).width();
                if (checkWidth <= 1024) {
                    if($('#navigationwrapper').is(":visible")){
                        /*$('.back-drop').css('top','0px').fadeToggle();
                        $('#navigationwrapper' ).animate({
                            opacity: "toggle"
                        });
                        $('.hamburger').toggleClass('is-active');*/
                        $( '.burger-wrapper .hamburger' ).click();
                    }
                }
                if (checkWidth <= 768) {
                    $('.pbackdrop').hide();
                    if($('.phone-details').hasClass('show')){
                        $('.phone-details').removeClass('show');
                    }
                }
            }
        }

        var btn = $('#totopbutton');
        var loadmoretestimonialstrigger = false;
        var _prod_btn = 0;
        var _prod_pos_normal = true;
        var _prod_pos_top = false;
        if($('.button-wrapper').length){
            _prod_btn = $(".button-wrapper").position().top;
        }
        $(window).scroll(function() {
            scrollXYpopupmode = $(window).scrollTop();
            if ($(window).scrollTop() > 300) {
              btn.addClass('show');
              if($('.tdtftp-wrapper').length){
                $('.tdtftp-wrapper').addClass('show-prod');
                if ($(window).width() > 768){
                    $('.site-footer').css({'margin-bottom':'45px'});
                }else{
                    $('.site-footer').css({'margin-bottom':'45px'});
                }
              }
            } else {
              btn.removeClass('show');
              if($('.tdtftp-wrapper').length){
                $('.tdtftp-wrapper').removeClass('show-prod');
                $('.site-footer').css({'margin-bottom':''});
              }
            }
            if ($(window).scrollTop() > 0){
                if($('.site-header').length){
                    /*$('.site-header').addClass('is-sticky');
                    $('#navigationwrapper').css('top','0px');*/
                }
            }else{
                if($('.site-header').length){
                    /*$('.site-header').removeClass('is-sticky');
                    $('.site-header').css({'width': ''});
                    $('#navigationwrapper').css('top','0px');*/
                    $('.pbackdrop').hide();
                    if($('.phone-details').hasClass('show')){
                        $('.phone-details').removeClass('show');
                    }
                }
            }
        });
        btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop:0}, '300');
        });

        function hideAddressBar(){
            setTimeout(function() {
                if(window.pageYOffset !== 0) return;
                window.scrollTo(0, window.pageYOffset + 1);
        
            }, 1000);
        }
$('.gallery-images').each(function() { // the containers for all your galleries
    $(this).magnificPopup({
        delegate: 'a', // the selector for gallery item
        type: 'image',
        gallery: {
            enabled:true
        }
    });
}); 
if($('.support-image').length){
    if ($(window).width() <= 768){
        $(document).on('click', '.support-image', function(e){
            document.location.href="tel:09177205365 ";
        });
    }
}
})(jQuery);

function setAppliance(url,el){
    var $ = jQuery;
    var _appliance = el.value;
    if(el.value == 'other'){
        _appliance = prompt('Type here the name of appliance');
    }
    var data = {'appliance' :_appliance, 'action' : 'socoteco2_ajax_appliance_set'};
    $.ajax({
        type: 'post',
        url: url,
        data: data,
        dataType: "json",
        success: function(res){
            if( res.success) {
                //$('#calculatorForm .appliances-wrapper').append( res.data );
                    $(el).parent().parent().find('.appliance-options').find('.form-select').find('option:last').before(res.data.appliance.data);
                    $(el).parent().parent().find('.technology-options:first').find('.form-select').html( res.data.tech.data);
                    $(el).parent().parent().find('.power-use:first').find('.power-user-wrapper:first').find('.power:first').val( res.data.unit.default);
                    $(el).parent().parent().find('.power-use:first').find('.power-user-wrapper:first').find('.power-unit:first').html( res.data.unit.data);
                    $(el).parent().parent().find('.electricity-usage-wrapper:first').find('.usage:first').val( res.data.usage.default);
                console.log(res);
            }else{
                console.log(res);
            }
        }
    });
}

function calculateBill(url){
    var $ = jQuery;
    if(!$('#estimateResult').hasClass('calculated-result')){
        $('#estimateResult').addClass('calculated-result');
    }
    $('#estimateResult .result-data-wrapper .result-table > tbody').find('tr').not(':last').each(function(){
        $(this).find('td').each(function(){
            $(this).html('<div class="linear-loading"></div>');
        });
    });
    $('#estimateResult .result-data-wrapper .result-table > tbody').find('tr:last').each(function(){
        $(this).find('td').each(function(){
            $(this).html('');
        });
    });
    var frmdata = $("#calculatorForm").serializeArray();
    frmdata.push({name: 'action', value: 'socoteco2_ajax_calculate_bill'});
    $.ajax({
        type: 'post',
        url: url,
        data: frmdata,
        dataType: "json",
        success: function(res){
            if( res.success) {
                //$('#calculatorForm .appliances-wrapper').append( res.data );
                setTimeout(() => {
                    $('#estimateResult .result-data-wrapper .result-table > tbody').html( res.data );
                }, 2000);
                //console.log(res);
            }else{
                console.log(res);
            }
        }
    });
}

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight+3}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

jQuery(window).load(function(){
    if(window.innerWidth < 769){
        if(jQuery('.grecaptcha-badge').length){
            jQuery('.grecaptcha-badge').css({"width":"0", "height":"0"});
        }
    }
});

var headlinenews = new Swiper(".soc-banner-headline", {
    loop: true,
    slidesPerView: 1,
    /*effect:'fade',*/
    rewind: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
  });

  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });
  var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 60,
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });

  var powerAdvisoriesthumbs = new Swiper(".power-advisories-home-thumb", {
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });

  var powerAdvisories = new Swiper(".power-advisories-home-slide", {
    slidesPerView: 1,
    fadeEffect: { crossFade: true },
    effect: "fade",
    pagination: {
        el: ".advisories-swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    speed: 3000,
    loop: true,
    /*navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: powerAdvisoriesthumbs,
    },*/
    on: {
        transitionStart: function(){
            var previousIndex = this.previousIndex;
            var previousSlide = document.getElementsByClassName('swiper-slide')[previousIndex];
            setTimeout(function() {
                previousSlide.firstElementChild.classList.remove('is-play');
            }, 3000);
        },
        transitionEnd: function(){
            var activeIndex = this.activeIndex;
            var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
            activeSlide.firstElementChild.classList.add('is-play');
        },
    },
});

 
var a = 0;
if(jQuery('.hstats').length){
    jQuery(window).scroll(function() {
    var oTop = jQuery('.hstats').offset().top - window.innerHeight;
    if (a == 0 && jQuery(window).scrollTop() > oTop) {
        jQuery('.stat').each(function() {
            var $this = jQuery(this).find('.value'),
                countTo = $this.attr('data-count'),
                $parent = jQuery(this);
                console.log($this.text());
            jQuery({ countNum: $this.text().replace('+','')+'+'}).animate({
            countNum: countTo
            },
        
            {
        
            duration: 8000,
            easing:'linear',
            step: function() {
                if($parent.hasClass('stat2')){
                    $this.text(Math.floor(this.countNum)+'+');
                }else if($parent.hasClass('stat3')){
                    $this.text(Math.floor(this.countNum)+'+');
                }else if($parent.hasClass('stat4')){
                    $this.text(Math.floor(this.countNum)+'+');
                }else{
                    $this.text(Math.floor(this.countNum));  
                }
            },
            complete: function() {
                if($parent.hasClass('stat2')){
                    $this.text(this.countNum + '+');
                }else if($parent.hasClass('stat3')){
                    $this.text(this.countNum + '+');
                }else if($parent.hasClass('stat4')){
                    $this.text(this.countNum + '+');
                }else{
                    $this.text(this.countNum);
                }
            }
        
            });  
        
        });
        a = 1;
    }else{

    }

    });
}
var abt_img_swapped = false;
jQuery(document).ready(function($){
    $('.site-container').css({'width':$(window).width() + 'px'});
    $('.tdtftp-wrapper.show-prod').css({'width':$(window).width() + 'px'});
    $('.site-header').css({'width': $(window).width()+'px'});
    if ($(window).width() <= 425){
        var hasimage =  $('#simplecontent_aboutpage .simple-content-wrapper > p').find('img');
        if(hasimage.length > 0){
         var imgcontent = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html();
         var nextp = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html();
         $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html(imgcontent);
         $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html(nextp);
         abt_img_swapped = true;
        }
        $(".fix-fixed").css({'height':'74px'});
     }
    if ($(window).width() <= 768){
        if((window.innerHeight-50) >= 600){
            $(".banner-section.home-page").css({'--fixed-height': '560px'});
        }else{
            $(".banner-section.home-page").css({'--fixed-height': (window.innerHeight-50) + 'px'});
        }
    var vw = $(document).width() * 0.01;
    console.log(vw);
    $(":root").css({'--vw':vw+'px'});
    //$(":root").css({'--app-height':`${window.innerHeight}px`});
        if($('.main-title-wrapper').length){
            $('.main-title-wrapper').parent().addClass('expanded');
        }
    }
    $(document).on('click','.phone-icon',function(e){
        e.preventDefault();
        //window.location.href = "tel:"+_g_phone_no;
        if ($(window).width() <= 768){
            $('.phone-details').toggleClass('show');
            var vh = $(document).height() * 0.01;
            $('.pbackdrop').css({'--vh':vh+'px'});
            $('.pbackdrop').fadeToggle();
        }else{
            window.location.href = "tel:"+_g_phone_no;
        }
    });
    $(document).on('click','#resetCalculateBillBtn',function(e){
        e.preventDefault();
        $('#calculatorForm')[0].reset();
        $('#calculatorForm').find('input[type="text"]').each(function(){
            $(this).val('');
        });
    });

    $(document).on('click','#removeAppliance',function(e){
        e.preventDefault();
        $(this).parent().parent().remove(); 
        if($('#estimateResult').hasClass('calculated-result')){
            $('#submitCalculateBillBtn').trigger( "click" );
        }
    });

    $(document).on('click','.btn-minus',function(e){
        e.preventDefault();
        var c_val = $(this).parent().find('.form-numeric-data:first').find('.unit_quantity:first').val();
        if(c_val > 1){
            c_val--;
        }
        $(this).parent().find('.form-numeric-data:first').find('.unit_quantity:first').val(c_val);
        $(this).parent().find('.form-numeric-data:first').find('.form-numeric-number:first').text(c_val);
    });
    $(document).on('click','.form-plus',function(e){
        e.preventDefault();
        var c_val = $(this).parent().find('.form-numeric-data:first').find('.unit_quantity:first').val();
        c_val++;
        $(this).parent().find('.form-numeric-data:first').find('.unit_quantity:first').val(c_val);
        $(this).parent().find('.form-numeric-data:first').find('.form-numeric-number:first').text(c_val);
    });

    if($('#singularpage').length){
        let calcC = setTimeout(() => {
            if($('#singularpage').hasClass('loading')){
                $('#singularpage').removeClass('loading');
            }
        }, 2000);
        //clearTimeout(calcC);
    }
    $(window).resize(function() {
        //$('#navigationwrapper').removeClass('show');
        //$( '.burger-wrapper .hamburger' ).click();
        //$('.hamburger').removeClass('is-active');
        $('.site-container').css({'width':$(window).width() + 'px'});
        $('.tdtftp-wrapper.show-prod').css({'width':$(window).width() + 'px'});
        $('.site-header').css({'width': $(window).width()+'px'});
        if ($(window).width() <= 960){
            $(".fix-fixed").css({'height':'58px'});
            if ($(window).width() <= 425){
                $(".fix-fixed").css({'height':'74px'});
            }
        }else{
            $("#top_bar").prependTo(".site-header");
            setTimeout(() => {
                $(".fix-fixed").css({'height':$('.site-header').height()+'px'});
            }, 300);
        }
        if(!abt_img_swapped){
            if ($(window).width() <= 425){
                var hasimage =  $('#simplecontent_aboutpage .simple-content-wrapper > p').find('img');
                if(hasimage.length > 0){
                        var imgcontent = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html();
                        var nextp = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html();
                        $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html(imgcontent);
                        $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html(nextp);
                        abt_img_swapped = true;
                }
            }
        }else{
            if ($(window).width() > 425){
                var hasimage =  $('#simplecontent_aboutpage .simple-content-wrapper > p').find('img');
                if(hasimage.length > 0){
                        var imgcontent = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html();
                        var nextp = $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html();
                        $('#simplecontent_aboutpage .simple-content-wrapper p').eq(1).html(imgcontent);
                        $('#simplecontent_aboutpage .simple-content-wrapper p').eq(0).html(nextp);
                        abt_img_swapped = false;
                }
            }
        }
        if ($(window).width() <= 768){
            if($('.main-title-wrapper').length){
                $('.main-title-wrapper').parent().addClass('expanded');
            }
        }
    });
    /*if($('#twoboxes').length){
        $('#twoboxes .box').on('touchstart, mouseenter', function (e) {
            'use strict';
            var link = $(this);
            if (link.hasClass('hover')) {
                return true;
            } else {
                link.addClass('hover');
                $('#twoboxes .box').not(this).removeClass('hover');
                e.preventDefault();
                return false; //extra, and to make sure the function has consistent return points
            }
        });
    }*/

    if($('.faq-section').length){
        $('.faq-section .blog-section .blog-wrapper .blog-item .title-wrapper').on('click', function(){
            $(this).parent().toggleClass("expanded");
            $(this).parent().find('.excerpt-wrapper').slideToggle();
        });
    }
    if($('#menu-header-menu').length){
        $('#menu-header-menu .sub-menu').css({'display':'block'});
        $('#menu-header-menu .sub-menu').css({'visibility':'hidden'});
        $('#menu-header-menu .sub-menu').css({'width':'100vw'});
        var lp_cnt = 1;
        $('#menu-header-menu').find('.sub-menu').each(function(sidx, submenu){
            var w_sub_menu = 0;
            var text_width = 0;
            $(submenu).find('.menu-item').each(function(idx,menuitem){
                var html_org = $(menuitem).find('a').html();
                var text_org = $(menuitem).find('a').text();
                var html_calc = '<span style"display:inline-block;width:100%;">'+html_org+'</span>';
                $(menuitem).find('a').html(html_calc);
                var width = $(menuitem).find('span:first').outerWidth();
                if(width > w_sub_menu){
                    w_sub_menu = width;
                }
                if(text_org.trim().length > text_width){
                    text_width = text_org.trim().length;
                }
                console.log('index :' + idx, 'width: ' + width, 'text width: '+text_width);
                $(menuitem).find('a').html(html_org);
            });
            if(lp_cnt == 1){
                $(this).css({'--submenu-width':(w_sub_menu+text_width+9.6)+'px'});
            }else{
                $(this).css({'--submenu-width':(w_sub_menu+text_width)+'px'});
            }
            $(this).css({'--parent-width':$(this).parent().innerWidth()+'px'});
            lp_cnt++;
        });
        $('#menu-header-menu .sub-menu').css({'width':''});
        $('#menu-header-menu .sub-menu').css({'display':''});
        $('#menu-header-menu .sub-menu').css({'visibility':''});
    }
    if($("#testimonials").length){
        $("#testimonials").find('img').each(function(idx){
            $(this).error(function () { 
                $(this).css({'visibility':'hidden'});
            });
        }); 
    }
    /** open inline popup */
	$('.open-inline-popup').magnificPopup({
		type:'inline',
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        removalDelay: 500,
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
	});
    /** popup image */
    $('.popup-image').magnificPopup({
        type: 'image',
        midClick: true, 
        removalDelay: 500,
    });

    /** video popup */
	$('.popup-youtube, .popup-vimeo, .popup-gmaps, .video-popup').magnificPopup({
		disableOn: 300,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 500,
		preloader: false,
		fixedContentPos: false,
        callbacks: {
            beforeOpen: function() {
            this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });

    var newsL = jQuery.map(($('#newsLabel').text() + '').split(''), function(val, index) {
        var delayval = index * 0.1;
        if(val.trim() == ''){
            val = '&nbsp;'; 
        }
        return '<span style="--delay:'+delayval+'s">'+val+'</span>';
    });
    $('#newsLabel').html(newsL);
    $($('#newsLabel span').get().reverse()).each(function(idx) { 
        var delayvalb = idx * 0.1;
        $(this).css({'--delayb':delayvalb+'s'});
    });

    setInterval(function(){
        $("#newsLabel").toggleClass("animate animateb");
    },4000);

    if($('.main-title-wrapper').length){
        $(document).on('click','.main-title-wrapper,.so-title-wrapper',function(){
            $(this).parent().toggleClass('expanded');
        });
    }
    $('.archives-wrapper .sym').on('click', function(e){
        if( $(this).parent().parent().hasClass('expand')){
          $(this).parent().parent().removeClass('expand');
          $(this).html('+');
        }else{
          if($('.archive-year').parent().hasClass('expand')){
            $('.archive-year').parent().removeClass('expand');
            $('.archives-wrapper .sym').html('+');
          }
          $(this).parent().parent().addClass('expand');
          $(this).html('-');
        }
    });
    $('.menu-contact-information').on('click',function(e){
        e.preventDefault();
        if ($(window).width() <= 768){
            $( '.burger-wrapper .hamburger' ).click();
        }
        var desire_top = 100;
        $('html, body').animate({
			scrollTop: $('#sitefooter').offset().top-desire_top
		  }, 800);
    });

    $('#checkstat').on('click',function(e){
        e.preventDefault();
        var refno = $('#refno').val();
        $('.status-result').hide();
        $('.loading-stat-container').show();
        $.ajax({
            type: 'post',
            url: "/wp-admin/admin-ajax.php",
            data:{
              'refno': refno,
              'action':'check_app_status'
            },
            dataType: "json",
            success: function(response){
                var res = JSON.parse(response.data);
                if(!response){
                    return;
                }
                $('.status-result .result').removeClass('on-process');
                $('.status-result .result').removeClass('pending');
                $('.status-result .result').removeClass('on-hold');
                $('.status-result .result').removeClass('energized');
                $('.status-result .result').removeClass('undefined');
                $('.status-result .result').addClass(res.status.body);
                $('.status-result .result').html(res.status.body);
                $('.status-result').show();
                $('.loading-stat-container').hide();
            }
          });
    });
    if($('.sidebar .sbox').length){
        $('.sidebar .sbox h2').on('click',function(e){
            e.preventDefault();
            if($(window).width() <= 768){
                if(!$(this).parent().find('.search-wrapper').length){
                    $(this).parent().toggleClass('show-submenu');
                }
            }
        });
    }
});

function showMore(id){
    document.getElementById(id+'Overflow').className='';
    document.getElementById(id+'MoreLink').className='hidden';
    document.getElementById(id+'LessLink').className='';
}

function showLess(id){
    document.getElementById(id+'Overflow').className='hidden';
    document.getElementById(id+'MoreLink').className='';
    document.getElementById(id+'LessLink').className='hidden';
}
var len = 150;
var shrinkables = document.getElementsByClassName('shrinkable');
if (shrinkables.length > 0) {
    for (var i = 0; i < shrinkables.length; i++){
        var fullText = shrinkables[i].innerHTML;
        if(fullText.length > len){
            var trunc = fullText.substring(0, len).replace(/\w+$/, '');
            var remainder = "";
            var id = shrinkables[i].id;
            remainder = fullText.substring(len, fullText.length);
            shrinkables[i].innerHTML = '<span>' + trunc + '<span class="hidden" id="' + id + 'Overflow">'+ remainder +'</span></span>&nbsp;<a id="' + id + 'MoreLink" href="#!" onclick="event.preventDefault(); showMore(\''+ id + '\');">More</a><a class="hidden" href="#!" id="' + id + 'LessLink" onclick="event.preventDefault(); showLess(\''+ id + '\');">Less</a>';
        }
    }
}



  
